import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import './components/assets/css/custom.css';
import './components/assets/css/datatable.css';
import './components/assets/css/impact.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primeicons/primeicons.css';
import { BrowserRouter } from 'react-router-dom';
import { PrimeReactProvider } from 'primereact/api';


const value = {
  ripple: true
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <PrimeReactProvider value={value}>
      <App />
    </PrimeReactProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
